
import React from "react";
import { Control } from "react-hook-form";
import { WorkoutType } from "@/models/WorkoutType";
import { useTranslation } from "react-i18next";
import { useSubscriptionManagement } from "./hooks/useSubscriptionManagement";
import SubscriptionFieldsHeader from "./SubscriptionFieldsHeader";
import SubscriptionItem from "./SubscriptionItem";
import SubscriptionEmptyState from "./SubscriptionEmptyState";

interface SubscriptionFieldsProps {
  control: Control<any>;
  workoutTypes: WorkoutType[];
}

const SubscriptionFields: React.FC<SubscriptionFieldsProps> = ({ control, workoutTypes }) => {
  const { t } = useTranslation();
  
  const {
    fields,
    selectedWorkoutTypeId,
    setSelectedWorkoutTypeId,
    openSections,
    availableWorkoutTypes,
    handleAddSubscription,
    handleWorkoutTypeSelect,
    handleRemoveSubscription,
    toggleSection,
    getWorkoutTypeName,
    getWorkoutTypeColor
  } = useSubscriptionManagement({ control, workoutTypes });

  return (
    <div className="space-y-4">
      {/* Add Subscription Section */}
      <SubscriptionFieldsHeader
        availableWorkoutTypes={availableWorkoutTypes}
        selectedWorkoutTypeId={selectedWorkoutTypeId}
        onWorkoutTypeSelect={handleWorkoutTypeSelect}
      />

      {/* Added Subscriptions */}
      {fields.length > 0 && (
        <div className="space-y-3">
          <h3 className="text-lg font-semibold">{t('clients.activeSubscriptions')}</h3>
          
          {fields.map((field: any, index) => {
            const workoutTypeName = getWorkoutTypeName(field.workoutTypeId);
            const workoutTypeColor = getWorkoutTypeColor(field.workoutTypeId);
            const isOpen = openSections[index] || false;
            
            return (
              <SubscriptionItem
                key={field.id}
                control={control}
                field={field}
                index={index}
                workoutTypeName={workoutTypeName}
                workoutTypeColor={workoutTypeColor}
                isOpen={isOpen}
                onToggle={() => toggleSection(index)}
                onRemove={() => handleRemoveSubscription(index)}
              />
            );
          })}
        </div>
      )}

      {/* Empty state */}
      {fields.length === 0 && (
        <SubscriptionEmptyState hasAvailableTypes={availableWorkoutTypes.length > 0} />
      )}
    </div>
  );
};

export default SubscriptionFields;
